import React from 'react';

import '../style/footer.css';

export default () => (
  <div className="footer">
    <h5>&copy; Full Scope Web, LLC 2019</h5>
  </div>
)